<template>
  <div id="doughnut-chart" v-if="datacollection.labels.length > 0">
    <el-row>
      <div class="small">
        <doughnut :max-fatias="maximoDeFatias" :chart-data="datacollection" :options="optionsGrafico"></doughnut>
      </div>
    </el-row>
  </div>
</template>
<script>
import Doughnut from '@/plugins/charts/Doughnut.js'
import 'chartjs-plugin-datalabels'
import { applyAlpha } from '@/utils/alphaColor'
import { mapGetters } from 'vuex'
export default {
  name: 'DoughnutChart',
  data () {
    return {
      datacollection: {
        datasets: [],
        labels: []
      },
      optionsGrafico: {
        legend: {
          position: 'right',
          labels: {
            fontSize: 14
          }
        },
        plugins: {
          datalabels: {
            color: '#FFFFFF',
            textShadowBlur: 3,
            textShadowColor: 'black',
            borderWidth: 2,
            font: {
              weight: 'normal',
              size: '16'
            },
            formatter: (value) => {
              return value + '%'
            }
          }
        },
        tooltips: {
          displayColors: false,
          callbacks: {
            label: function (tooltipItem, data) {
              return `${data.datasets[0].data[tooltipItem.index]}%`
            },
            title: function (tooltipItem, data) {
              return `${data.labels[tooltipItem[0].index]}`
            }
          }
        },
        responsive: true,
        maintainAspectRatio: false
      }
    }
  },
  components: {
    Doughnut
  },
  computed: {
    ...mapGetters('SetupApp', ['estilo'])
  },
  props: {
    maximoDeFatias: {
      type: Number,
      default: 5
    },
    graficoData: {
      type: Object,
      required: true
    }
  },
  methods: {
    async fillData (data, versaoIntegracao = 1) {
      let corLabel = this.estilo.aplicacao.corPrimariaAplicacao
      let totalCooparticipacao = null

      const valorCoparticipacaoKey = versaoIntegracao === 1 ? 'valorCoparticipacao' : 'valorTotalCoparticipacao'
      if (data.length) {
        totalCooparticipacao = data.map((item) => {
          const quantidade = versaoIntegracao === 1 ? item.quantidade : 1
          return quantidade * item[valorCoparticipacaoKey]
        })
          .reduce((item, total) => total + item)
      }
      const result = data.reduce(function (r, a) {
        r[a.idTipoServico] = r[a.idTipoServico] || []
        r[a.idTipoServico].push(a)
        return r
      }, Object.create(null))

      const dataset = {
        data: [],
        backgroundColor: [],
        hoverOffset: 4
      }
      const labels = []

      let porcentagemAlpha = 100

      let totalDeFatias = Object.keys(result).length

      let slicePorcentagemAlfa = 100 / totalDeFatias

      let fatiasDoGrafico = Object.entries(result).slice(0, this.maximoDeFatias).map(entry => entry[1])

      let fatiaOutros = Object.entries(result).slice(this.maximoDeFatias, totalDeFatias).map(entry => entry[1].pop())

      let valoresOutros = []

      fatiasDoGrafico.forEach((fatia, i) => {
        let valor = fatia.map(item => item[valorCoparticipacaoKey])
        let quantidade = fatia.map(item => item.quantidade)

        const gastoCooparticipacao = valor.map((val, i) => {
          const quantidadeElement = versaoIntegracao === 1 ? quantidade[i] : 1
          return val * quantidadeElement
        }).reduce((item, total) => {
          return item + total
        }, 0)

        const porcentagemGasto = ((gastoCooparticipacao / totalCooparticipacao) * 100).toFixed(1)
        if (porcentagemGasto < 10 && totalDeFatias > this.maximoDeFatias) {
          valoresOutros.push(gastoCooparticipacao)
        } else if (porcentagemGasto > 0) {
          labels.push(`${fatia[0].descricaoTipoServico} - ${porcentagemGasto}%`)
          dataset.data.push(porcentagemGasto)
          dataset.backgroundColor.push(applyAlpha(corLabel, porcentagemAlpha))
          porcentagemAlpha -= slicePorcentagemAlfa.toFixed(0)
        }
      })

      let totalOutros = valoresOutros.reduce((total, numero) => total + numero, 0)

      if (fatiaOutros.length) {
        let valor = []
        let quantidade = []
        let total = null
        fatiaOutros.forEach((fatia, i) => {
          valor.push(fatia[valorCoparticipacaoKey])
          quantidade.push(fatia.quantidade)
        })
        const gastoCooparticipacao = valor.map((val, i) => {
          const quantidadeElement = versaoIntegracao === 1 ? quantidade[i] : 1
          return val * quantidadeElement
        }).reduce((item, total) => {
          return item + total
        }, 0)

        total = gastoCooparticipacao + totalOutros

        total.toFixed(1)
        const porcentagemGasto = ((total / totalCooparticipacao) * 100).toFixed(1)
        dataset.data.push(porcentagemGasto)
        labels.push(`Outros - ${porcentagemGasto}%`)
        dataset.backgroundColor.push(applyAlpha(corLabel, porcentagemAlpha))
        porcentagemAlpha -= slicePorcentagemAlfa.toFixed(0)
      }
      this.datacollection = { datasets: [dataset], labels }
    }
  }
}

</script>
<style>
#doughnut-chart {
  height: 400px;
}
.small {
  margin: auto;
  height: 250px;
}
canvas {
  display: block;
  margin-left: auto;
  margin-right: auto;
  height: 250px;
}
</style>
